export function getSessionId(): string | undefined {
  if (typeof window === 'undefined') {
    return;
  }

  const raw = window.sessionStorage.getItem('__yvse');
  if (!raw) {
    return;
  }

  try {
    const { id } = JSON.parse(raw);
    return id;
  } catch {
    console.warn('could not parse __yvse');
    return;
  }
}
